"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const localbase_1 = require("localbase");
class IndexedDB {
    constructor(user) {
        this.db = new localbase_1.default(`db-${user}`);
        this.db.config.debug = false;
        this.collectionsKey = {};
    }
    addKey(collection, key) {
        this.collectionsKey = {
            [collection]: key
        };
    }
    addCollection(collection, data) {
        const key = this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .set(data.map((res) => (Object.assign(Object.assign({}, res), { _key: res[key] }))), { keys: true })
            .then((result) => result)
            .catch((error) => error);
    }
    deleteCollection(collection) {
        delete this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .delete()
            .then((result) => result)
            .catch((error) => error);
    }
    getAll(collection) {
        const key = this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .get()
            .then((result) => result)
            .catch((error) => error);
    }
    getById(collection, id) {
        const key = this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .doc(id)
            .get()
            .then((result) => result)
            .catch((error) => error);
    }
    getByField(collection, field, fieldValue) {
        const key = this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .doc({ [field]: fieldValue })
            .get()
            .then((result) => result)
            .catch((error) => error);
    }
    add(collection, data) {
        const key = this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .add(data, data[key])
            .then((result) => result)
            .catch((error) => error);
    }
    addBatch(collection, data) {
        const key = this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .set(data.map((d) => (Object.assign(Object.assign({}, d), { _key: key }))), { keys: true })
            .then((result) => result)
            .catch((error) => error);
    }
    update(collection, data) {
        const key = this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .doc(data[key])
            .update(data)
            .then((result) => result)
            .catch((error) => error);
    }
    updateById(collection, data) {
        return this.db
            .collection(collection)
            .doc({ _id: data._id })
            .update(data)
            .then((result) => result)
            .catch((error) => error);
    }
    delete(collection, id) {
        const key = this.collectionsKey[collection];
        return this.db
            .collection(collection)
            .doc({ _id: id })
            .delete()
            .then((result) => result)
            .catch((error) => error);
    }
}
exports.default = IndexedDB;
